
export const PdfComponsnts = [
    {
        category: "Text",
        components: [
            {
                type: "SINGLE_ROW_TEXT",
                name: "نص صف واحد",
                icon: "pi-pencil",
                value: '',
                placeholder: "Enter your text here",
                position: {
                    x: 0,
                    y: 0
                }
            },
            {
                type: "RICH_TEXT",
                name: "Rich Text",
                icon: "pi-pencil",
                value: '',
                placeholder: "Enter your text here",
                position: {
                    x: 0,
                    y: 0
                }
            }
        ]
    }
]